module.exports = __webpack_public_path__ + "static/media/auditoriumP.f3bea291.jpg";